export class ParticipantController {
    public participant: any;
    public league: any;
    public loaded: boolean = false;
}